import { NgModule } from '@angular/core';
import { AppLoaderComponent } from './app-loader.component';
import { AppLottieAnimationComponent } from '@app/shared-components/lottie-animation/lottie-animation.component';
import { CommonModule } from '@angular/common';
@NgModule({
    declarations: [
        AppLoaderComponent,
    ],
    imports: [AppLottieAnimationComponent, CommonModule],
    exports: [
        AppLoaderComponent
    ]
})
export class AppLoaderModule { }
